import { createReducer } from '../../../store.model';

import { DeleteItem } from './state/delete-item.action';
import { deleteItemReducer } from './state/delete-item.reducer';
import { EditItem } from './state/edit-item.action';
import { editItemReducer } from './state/edit-item.reducer';
import { FilterItems } from './state/filter-items.action';
import { filterItemsReducer } from './state/filter-items.reducer';
import { ReceiveItems } from './state/receive-items.action';
import { receiveItemsReducer } from './state/receive-items.reducer';
import { Reload } from './state/reload.action';
import { reloadReducer } from './state/reload.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';
import { SortItems } from './state/sort-items.action';
import { sortItemsReducer } from './state/sort-items.reducer';
import { ToggleSearch } from './state/toggle-search.action';
import { toggleSearchReducer } from './state/toggle-search.reducer';
import { UpdateItem } from './state/update-item.action';
import { updateItemReducer } from './state/update-item.reducer';
import { ActionType } from './task-list-dialog.action';
import { defaultState, TaskListDialogState } from './task-list-dialog.state';

const { builder, reducer } = createReducer<ActionType, TaskListDialogState>(
    defaultState(),
);

builder.add<Reload>(ActionType.TC__TL__RELOAD, reloadReducer);

builder.add<ToggleSearch>(
    ActionType.TC__TL__TOGGLE_SEARCH,
    toggleSearchReducer,
);

builder.add<FilterItems>(ActionType.TC__TL__FILTER_ITEMS, filterItemsReducer);

builder.add<ReceiveItems>(
    ActionType.TC__TL__RECEIVE_ITEMS,
    receiveItemsReducer,
);

builder.add<UpdateItem>(ActionType.TC__TL__UPDATE_ITEM, updateItemReducer);

builder.add<SortItems>(ActionType.TC__TL__SORT_ITEMS, sortItemsReducer);

builder.add<EditItem>(ActionType.TC__TL__EDIT_ITEM, editItemReducer);

builder.add<DeleteItem>(ActionType.TC__TL__DELETE_ITEM, deleteItemReducer);

builder.add<Reset>(ActionType.TC__TL__RESET, resetReducer);

export const taskListDialogReducer = reducer;
